import { createQueryKeys } from '@lukemorales/query-key-factory';
import { deviceApis } from '../../apis/device/apis';
import { planApis } from '../../apis/plan/apis';
import type { IGetDevicePlanDetailParams } from '../../apis/plan/types';
import type {
  IGetDeviceInfoParams,
  IGetDistributorCompanyParams,
  IModlinkInternalList,
} from '../../apis/device/management/types';
import type { Device, DistributorCompany, IDeviceExtendHistory } from '../../types/device';

export const devicesQueries = createQueryKeys('devices', {
  planDetails: (params: IGetDevicePlanDetailParams) => ({
    queryKey: [params.id],
    queryFn: async () => {
      const response = await planApis.getDevicePlanDetail(params);
      return response.data;
    },
  }),
  aggregation: () => ({
    queryKey: ['devices', 'summary'],
    queryFn: async (): Promise<{
      totalDeviceCount: number;
      recentRegisteredDeviceCount: number;
      expiringSoonDeviceCount: number;
    }> => {
      const response = await deviceApis.management.getDeviceAggregation();
      return response.data;
    },
  }),
  extendHistory: (params) => ({
    queryKey: [params.mac],
    queryFn: async (): Promise<{
      data: IDeviceExtendHistory[];
      total: number;
    }> => {
      const response = await deviceApis.service.getExtendHistory(params);
      return response.data;
    },
  }),
  list: (params: IModlinkInternalList) => ({
    queryKey: [params],
    queryFn: async (): Promise<{ data: Device[]; total: number }> => {
      const response = await deviceApis.management.getTotalDeviceList(params);
      return response.data;
    },
  }),
  details: (params: IGetDeviceInfoParams) => ({
    queryKey: [params.id],
    queryFn: async (): Promise<Device> => {
      const response = await deviceApis.management.getDeviceInfo(params);
      return response.data;
    },
  }),
  distributorCompany: (params: IGetDistributorCompanyParams) => ({
    queryKey: [params.mac],
    queryFn: async (): Promise<DistributorCompany> => {
      const response = await deviceApis.management.getDistributorCompany(params);
      return response.data;
    },
  }),
});
